


import { toast } from 'react-toastify';
import axiosInstance from '../../config';

export const getHistoryDataService = async (token) => {

    try {


        const response = await axiosInstance.get('ui/payment_history',
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },

            })

        console.log("error res", response)
        return {
            success: true,

            data: response.data,
            status: response.status,

        };


    }
    catch (error) {
        console.log("errorres", error?.response)
        if (error.response) {
            // Handle rate limit specifically
            if (error.response.status === 429) {
                const message = error.response.data?.detail || "Something went wrong";
                toast.error(`⚠️ ${message}`);
            }
            else {
                // Show API-provided error message if exists
                const message = error.response.data?.detail || "Something went wrong";
                // toast.error(`⚠️ ${message}`);
            }
        } else {
            // Network or other errors
            toast.error(`⚠️ ${error.message}`);
        }

        return {
            success: false,
            message: error.response?.data?.message || "Fetch Event failed",
            status: error.response?.status || 500,
            errors: error.response?.data?.errors || null,


        };

    }


}



